import "./src/styles/global.css";

// Chatbot widget loader for mgmt.tools
import React, { useEffect } from 'react';

const MGMT_TOOLS_BOT_ID = 'cd94c8efa3c64a97a9784153fe408ac3';
const DEFAULT_MGMT_TOOLS_BASE_URL = process.env.GATSBY_MGMT_TOOLS_BASE_URL || 'https://mgmt.tools/account';

const ChatbotScriptLoader = () => {
  useEffect(() => {
    if (typeof document === 'undefined') return;

    // Avoid injecting the script multiple times
    const existingScript = document.querySelector('script[data-mgmt-chatbot-widget="true"]');
    if (existingScript) return;

    const baseUrl = DEFAULT_MGMT_TOOLS_BASE_URL.replace(/\/$/, '');
    const script = document.createElement('script');

    script.async = true;
    script.src = `${baseUrl}/static/chatbot/widget.js`;
    script.dataset.mgmtChatbotWidget = 'true';
    script.dataset.botId = MGMT_TOOLS_BOT_ID;
    script.dataset.baseUrl = baseUrl;

    document.body.appendChild(script);
  }, []);

  return null;
};

// Wrap the entire app and load external chatbot widget
export const wrapRootElement = ({ element }) => {
  return (
    <>
      {element}
      <ChatbotScriptLoader />
    </>
  );
};
